import myJFrogUtils from "@shared/utils/myJFrogUtils.ts";
import { sleep } from "@shared/utils/tools.ts";
import {
  type CreateDomainVerificationRequest,
  type DnsTxtVerificationDto,
} from "@shared/types/localTypes/domains.ts";

export default async (data?: object) => {
  const request = data as CreateDomainVerificationRequest;
  await sleep(350);
  const uuid = myJFrogUtils.generateUUIDv4();
  return {
    verification_uuid: uuid,
    method: request.verification_method,
    status: "pending",
    last_verified_at: null,
    details: {
      txt_record_value: `jfrog-verify=tour-token-${uuid.slice(0, 8)}`,
      last_checked: null,
    },
  } satisfies DnsTxtVerificationDto;
};
